import { useFiltersConfigBuilder } from "./useFiltersConfigBuilder";

export default useFiltersConfigBuilder;
